import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { Toaster } from '@app/services/toaster/toaster.service';
import { SharedModule } from '@app/shared/shared.module';
import { ListsService } from '../lists.service';
import { iUser } from '../user.interface';
import { ListsApi } from '../lists.api';
import { ViewUserComponent } from '../view-user/view-user.component';
import { AdPushComponent } from '@app/shared/components/ads/ad-push/ad-push.component';

@Component({
	selector: 'app-view-list-home',
	standalone: true,
	imports: [
		SharedModule,
		ViewUserComponent,
		AdPushComponent,
	],
	providers: [
		ListsService,
		ListsApi,
	],
	templateUrl: './view-list-home.component.html',
	styleUrl: './view-list-home.component.scss'
})
export class ViewListHomeComponent implements OnInit {
	private hash!:string;
	public loading:boolean = false;
	public user?: iUser;
	public title: string = "Ver lista ...";
	public subtitle: string = "Apostas ...";
	public viewErrorBox:boolean = false;

	constructor (
		private route: ActivatedRoute,
		private toast: Toaster,
		private nav: NavigationService,
		private service: ListsService,
	) { }

	ngOnInit(): void {
		const h = this.route.snapshot.paramMap.get("hash");
		if(!h) {
			this.toast.error("Não foi possível identificar o hash!");
			this.nav.goHome();
			return;
		}
		this.hash = h;
		this.loadList();
	}

	public loadList() {
		this.loading = true;
		this.service.view(this.hash)
			.subscribe({
				next: (rs) => {
					this.user = rs;
					this.title = `Lista de ${rs.name}`;
					this.subtitle = `Apostas para o ano de ${rs.year}`;
					this.loading = false;
				},
				error: (err) => {
					console.error(err);
					this.title = "Erro!";
					this.subtitle = "Não foi possível recuperar as apostas!";
					this.loading = false;
					this.viewErrorBox = true;
				}
			});
	}

}
